import {React, useState} from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { signOut } from "aws-amplify/auth";
import IconButton from '@mui/material/IconButton';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import RateReviewIcon from '@mui/icons-material/RateReview';
import { Link } from 'react-router-dom';
import FeedbackModal from './Feedback/FeedbackModal';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import DevelopmentPlanSelector from "./DevelopmentPlanSelector";
import EditIcon from '@mui/icons-material/Edit';
import ComparisonPanel from '../Not-Currently-Used/ComparePlans/ComparisonPanel';
import { useMapContext } from '../../contexts/MapContext';



const MenuBar = () => {
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const [feedbackAnchorEl, setFeedbackAnchorEl] = useState(null);
  const [logoutAnchorEl, setLogoutAnchorEl] = useState(null);

  const { 
    userData,
    devPlanID,
    editMode, 
    handMode,
    plansStillRunning,
    progressValue,
    setProgressValue,
    planIsRunning,
    outFileExists,
  } = useMapContext();

  const editIconColor = editMode? '#1E90FF' : '#ffffff';

  const devPlanHasntRun = !planIsRunning && !outFileExists //userData && !containPlan(selectedStormOption, userData.id, devPlanID);

  const handleFeedbackOpen = () => {
    setFeedbackModalOpen(true);
    setFeedbackAnchorEl(null);
  };

  const handleFeedbackClose = () => {
    setFeedbackModalOpen(false);
  };

  const handleSignOut = async () => {
    try {
      await signOut();
      window.location.reload(); // Optionally reloads the page after sign out
    } catch (error) {
      console.log('Error signing out: ', error);
    }
    setLogoutAnchorEl(null);
  };

  const handleFeedbackMenuClick = (event) => {
    setFeedbackAnchorEl(event.currentTarget);
  };

  const handleLogoutMenuClick = (event) => {
    setLogoutAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setFeedbackAnchorEl(null);
    setLogoutAnchorEl(null);
  };


  const handlePrintStates = () => {
    console.log("plansStillRunning");
    console.log(plansStillRunning);

    console.log("progressValue");
    console.log(progressValue);
    console.log("setProgressValue");
    console.log(setProgressValue);

    console.log("handMode");
    console.log(handMode);

    console.log("combined = = = = = = = = = = = = = = = = = = = = = = = =");
    console.log("GLWA_Aug16_" + userData.id + "_" + devPlanID);
  }
  const debug = false;


  return (
    <AppBar position="static" sx={{ backgroundColor: 'black', zIndex: 1000}}>
      <Toolbar>
        <a href="http://digitalwaterlab.org/" target="new">
          <img 
            src="https://images.squarespace-cdn.com/content/63121bdc04e1e907fe9ed158/a1b80031-f98d-45a6-b078-75ac671238ed/WaterDrop.png?content-type=image%2Fpng" 
            alt="Digital Water Lab Logo" 
            style={{ marginRight: 10, marginTop: 10, marginBottom: 10, height: '40px' }} 
          />
        </a>
        

        <Typography 
          variant="h6" 
          sx={{ flexGrow: 0, fontFamily: 'Helvetica, Arial, sans-serif', fontWeight: 'light', marginRight: 4 }}
          component={Link}
          to="/"
          onClick={() => window.open('http://digitalwaterlab.org/', '_blank')}
          style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}
        >
          SewerTycoon Detroit
        </Typography>


        <DevelopmentPlanSelector/>

        {devPlanHasntRun && false &&(
            <IconButton
              color="primary"
              sx={{ marginRight: 2 }}
            >
              <EditIcon sx={{ color: editIconColor }}/>
          </IconButton>
        )}

        {debug &&
          <ComparisonPanel />
        }

        {debug &&
          <IconButton
            color="inherit"
            sx={{ marginRight: 2 }}
            onClick={handlePrintStates}
          >
            <RateReviewIcon sx={{ fontSize: 28 }} />
          </IconButton>
        }

        <IconButton
            color="inherit"
            sx={{ marginRight: 2 }}
            onClick={handleFeedbackMenuClick}
          >
            <RateReviewIcon sx={{ fontSize: 28 }} />
        </IconButton>

        <Menu
          anchorEl={feedbackAnchorEl}
          open={Boolean(feedbackAnchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleFeedbackOpen}>Feedback</MenuItem>
        </Menu>

        <IconButton
          color="inherit"
          sx={{ marginRight: 2 }}
          onClick={handleLogoutMenuClick}
        >
          <AccountCircleIcon sx={{ fontSize: 28 }} />
        </IconButton>

        <Menu
          anchorEl={logoutAnchorEl}
          open={Boolean(logoutAnchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleSignOut}>Logout</MenuItem>
        </Menu>
      </Toolbar>

      <FeedbackModal open={feedbackModalOpen} onClose={handleFeedbackClose} />
    </AppBar>
  );
};

export default MenuBar;